import React from 'react';
import { withRouter } from 'react-router-dom';
import { useForm } from 'react-hook-form';
import { useStateMachine } from 'little-state-machine';
import updateAction from '../../updateAction';

import BackButton from '../../components/BackButton';
import Button from '../../components/Button';
import Input from '../../components/Input';
import StackForm from '../../components/StackForm';
import Title from '../../components/Title';
// import Label from '../../components/Label';
// import RadioGroup from '../../components/RadioGroup';

import { useGlobalData } from '../../../store';

const Data = props => {
  const { register, errors, handleSubmit, triggerValidation } = useForm({
    mode: 'onBlur',
  });
  const { action, state } = useStateMachine(updateAction);
  const { setGlobalData } = useGlobalData();

  const onSubmit = data => {
    action(data);
    props.history.push('/2');
  };

  return (
    <StackForm onSubmit={handleSubmit(onSubmit)}>
      <div>
        <Title>Decinos las necesidades de tu préstamo en tarjeta de crédito.</Title>

        {/* <Label mb={10}>Moneda</Label>

        <RadioGroup
          type="pill"
          name="moneda"
          options={[
            {
              label: 'UYU',
              value: 'UYU',
              id: 'moneda-uyu',
            },
            {
              label: 'USD',
              value: 'USD',
              id: 'moneda-usd',
            },
          ]}
          register={register({ required: 'Este campo es obligatorio.' })}
          error={errors.moneda}
          defaultChecked={state?.data?.moneda}
          onChange={e => setGlobalData({ moneda: e.target.value })}
        /> */}

        <Input
          type="text"
          label="Monto del préstamo"
          placeholder="Ingresá el monto del préstamo"
          id="monto"
          name="monto"
          defaultValue={state?.data?.monto}
          register={register({ required: 'Este campo es obligatorio.' })}
          error={errors.monto}
          mask={{
            numeral: true,
            numeralDecimalMark: ',',
            delimiter: '.',
          }}
          triggerValidation={() => triggerValidation('monto')}
          onChange={e => setGlobalData({ monto: e.target.value })}
        />
      </div>

      <div className="form-actions">
        <Button block type="submit" id="pTC_siguiente_2">
          siguiente
        </Button>

        <BackButton
          onClick={() => document.referrer && (window.location.href = document.referrer)}
        />
      </div>
    </StackForm>
  );
};

export default withRouter(Data);
